import React, { useEffect, useId, useRef } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

type Props = {
  isOpen: boolean;
  title: string;
  value: string;
  onChange: (value: string) => void;
  onCancel: () => void;
  onSave: () => void;
  isSaving: boolean;
};

export function RenameConversationModal({
  isOpen,
  title,
  value,
  onChange,
  onCancel,
  onSave,
  isSaving
}: Props) {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const inputId = useId();

  useEffect(() => {
    if (!isOpen) return undefined;
    window.setTimeout(() => inputRef.current?.focus(), 0);
    return undefined;
  }, [isOpen]);

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(next) => {
        // Escape and the close button land here.
        if (!next && !isSaving) onCancel();
      }}
    >
      <DialogContent aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-1.5">
          <Label htmlFor={inputId}>Conversation Name</Label>
          <Input
            id={inputId}
            ref={inputRef}
            placeholder="Untitled conversation"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                if (!isSaving) onSave();
              }
            }}
          />
        </div>

        <DialogFooter>
          <Button variant="ghost" onClick={onCancel} disabled={isSaving}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onSave} disabled={isSaving}>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default RenameConversationModal;
